// base64url ↔ bytes. One copy.
//
// This was written three times — faceClockCrypto (evidence + location
// ciphertext), faceClockHmac (the kiosk's pairing secret) and
// deviceOfflineCache (the roster's IV and ciphertext) each carried an identical
// decoder. All three feed `crypto.subtle`, where a decoder that differs by one
// character produces a key or a payload that is silently wrong rather than an
// error, so having three of them was a standing invitation to fix a bug in one
// and leave it in the other two.
//
// ⚠️ NOT for the per-device HMAC secret. That is HEX and goes through
// `deviceSecretBytes()` in src/lib/deviceSecret.ts — running it through here
// SUCCEEDS (hex's alphabet is a subset of base64's) and yields a different key,
// which is exactly the bug Phase 4e found.

/**
 * base64url → bytes. Accepts padded or unpadded, '-'/'_' or '+'/'/'.
 *
 * The padding is restored before `atob`, which rejects an unpadded string.
 */
export function base64urlToBytes(s: string): Uint8Array {
  const b64 = s.replace(/-/g, '+').replace(/_/g, '/')
            + '==='.slice(0, (4 - s.length % 4) % 4)
  const bin = atob(b64)
  const out = new Uint8Array(bin.length)
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i)
  return out
}

/** bytes → standard base64 (padded). */
export function bytesToBase64(b: Uint8Array): string {
  let s = ''
  for (let i = 0; i < b.length; i++) s += String.fromCharCode(b[i])
  return btoa(s)
}
